import QuestionViewVerbalEquivalent from "./QuestionViewVerbalEquivalent";

export default class QuestionViewVisualEquivalent extends QuestionViewVerbalEquivalent{
    constructor(question) {
        super(question);
    }

    createStatement(spacing = 40) {
    }

    setAnswer(value) {
        this._inputValue = value;

        if (!Array.isArray(value) && this._inputField != null) {
            if (value) {
                const str = value.toString();
                this._inputField.label.text = str;
                this._inputField.label.style.fontSize = str.length < 5 ? 40 : 20;
            } else {
                this._inputField.label.text = "?";
                this._inputField.label.style.fontSize = 40;
            }
        }
    }

    initInputField() {
    }

    isCorrect() {
        let correctValues = [];
        for (let i = 0; i < this.question.part.length; i++)
        {
            correctValues.push(this.question.values[this.question.part[i]]);
        }

        if (Array.isArray(this._inputValue))
        {
            if (this._inputValue.length > 0 && this._inputValue.length === correctValues.length)
            {
                let count = this._inputValue.length;
                for (let i = 0; i < count; i++)
                {
                    let isCorrect = false;
                    let input = this._inputValue[i].value;

                    for (const correctValue in correctValues)
                    {
                        if (correctValues.hasOwnProperty(correctValue))
                        {
                            if (correctValues[correctValue].value === input)
                            {
                                isCorrect = true;
                                break;
                            }
                        }
                    }

                    if (isCorrect === false)
                    {
                        return false;
                    }

                    return true;
                }
            }
            else
            {
                return false;
            }
        }
        else
        {
            if (this._inputValue === correctValues[0])
            {
                return true;
            }
        }
        return false;
    }
}